import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { User, ArrowRight } from 'lucide-react'

export default function Team() {
  return (
    <section id="team" className="relative py-24 md:py-32 bg-accent overflow-hidden">
      <div className="absolute inset-0 bg-[url('/assets/bg-noise.png')] opacity-10 mix-blend-overlay pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-accent/80 via-transparent to-accent pointer-events-none" />

      <div className="container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-sm font-bold text-white/70 uppercase tracking-[0.2em] mb-6">Who We Are</h2>
          <h3 className="text-4xl md:text-6xl font-bold font-heading text-white uppercase tracking-tight leading-[0.95]">
            Founder-Led. <br /> <span className="text-white/90">Expert-Backed.</span>
          </h3>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          {/* Founder */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="flex flex-col sm:flex-row items-center sm:items-start gap-8 mb-16"
          >
            <div className="aspect-square w-40 flex-shrink-0 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/10 flex items-center justify-center overflow-hidden">
              <User className="w-16 h-16 text-white/20" strokeWidth={1} />
            </div>
            <div className="text-center sm:text-left">
              <h4 className="text-2xl font-bold font-heading text-white uppercase tracking-tight mb-1">
                Jono
              </h4>
              <p className="text-sm font-bold text-white/60 uppercase tracking-wider mb-4">
                Founder & Director
              </p>
              <p className="text-white/70 leading-relaxed">
                Hands-on strategist with enterprise experience across digital marketing, analytics, and product development. Built Gigafish to give challenger brands the same calibre of thinking that big corporates take for granted — without the overhead or the red tape.
              </p>
            </div>
          </motion.div>

          {/* Specialist Network */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-8 md:p-10 text-center"
          >
            <h4 className="text-lg font-bold font-heading text-white uppercase tracking-tight mb-3">
              Lean by Design
            </h4>
            <p className="text-white/70 leading-relaxed max-w-xl mx-auto mb-6">
              We keep the core team small and supplement with a vetted network of specialist partners — designers, developers, media buyers, and copywriters — so you get senior expertise across every discipline without paying for a bloated agency bench.
            </p>
            <Link
              to="/new-project"
              className="inline-flex items-center gap-2 text-white font-bold text-sm uppercase tracking-wider hover:text-white/80 transition-colors group"
            >
              Work with us
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
